import React from 'react';
import { NumberService } from 'Services';
import { Field, FieldProps } from 'formik';
import { InputBase } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import styles from './OverallThresholdInput.css';

type Props = {
    maxGlobalAggregateThreshold: number;
    thresholdText: React.ReactNode;
    hasError: boolean;
    name: string;
};

const OverallThresholdInput = ({ maxGlobalAggregateThreshold, thresholdText, hasError, name }: Props) => {
    const { t } = useTranslation();

    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => (
                <div className={styles.threshold}>
                    <div className={styles.thresholdDescription}>{thresholdText}</div>
                    <div className={styles.inputBaseContainer}>
                        <InputBase
                            className={styles.thresholdInput}
                            name={name}
                            id={name}
                            size='sm'
                            type='number'
                            value={field.value}
                            error={hasError}
                            onChange={(val) => {
                                form.setFieldValue(field.name, val.target.value);
                            }}
                            onBlur={field.onBlur}
                            data-testid='overall-threshold-field'
                            allowPan
                            min={0}
                            max={maxGlobalAggregateThreshold}
                        />
                        {hasError && (
                            <div className={clsx(styles.validationField, hasError && styles.hasError)}>
                                {t('Threshold must be between {{min}} and {{max}}', {
                                    min: NumberService.getLocaleNumber(0),
                                    max: NumberService.getLocaleNumber(maxGlobalAggregateThreshold)
                                })}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Field>
    );
};

export default OverallThresholdInput;
